"use strict";
// Copyright 2017-2018 Stratumn SAS. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var errors = __importStar(require("./errors"));
/**
 * A reference to a link that can be in another process.
 */
var LinkReference = /** @class */ (function () {
    function LinkReference(linkHash, process) {
        if (!process) {
            throw errors.ErrLinkProcessMissing;
        }
        if (!linkHash || linkHash.length === 0) {
            throw errors.ErrLinkHashMissing;
        }
        this.linkHash = linkHash;
        this.process = process;
    }
    return LinkReference;
}());
exports.LinkReference = LinkReference;
//# sourceMappingURL=ref.js.map